export default "__VITE_PUBLIC_ASSET__89153084__"